module.exports = __webpack_public_path__ + "static/assets/ee36ce44120e83f164d63e89f4c75425.png";